import { fulfillmentApi } from '../../../api/fulfillmentApi';
import { AppDispatch, RootState } from '../../store';
import { setReasons, startLoadingReasons } from './reasonsSlice';

export const getReasons = () => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingReasons());
        const resp = await fulfillmentApi.get(`reasons/adjustment`);
        let reasons = resp.data;

        dispatch(setReasons({ reasons }));
    }
}